module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.16d7bb9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/Roboto-Bold/Roboto-Bold.ttf
// module id = dtGT
// module chunks = 16